import React from 'react';

import ContentTypes from './types';

const Manual = ({ type, ...props }) => {
  return React.createElement(ContentTypes[type], { ...props });
};

export default Manual;
